import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SettingsContext, initialState, defaultSettings } from './settings-context';

const STORAGE_KEY = 'app.theme';

const restoreTheme = () => {
  try {
    const restored = window.localStorage.getItem(STORAGE_KEY);
    if (restored) {
      const parsed = JSON.parse(restored);
      if (parsed.paletteMode && ['light', 'dark'].includes(parsed.paletteMode)) {
        return parsed.paletteMode;
      }
    }
  } catch (err) {
    console.error(err);
  }
  return defaultSettings.paletteMode;
};

export const SettingsProvider = (props) => {
  const { children } = props;
  const [paletteMode, setPaletteMode] = useState(restoreTheme);

  const handleToggleTheme = useCallback(() => {
    const next = paletteMode === 'light' ? 'dark' : 'light';
    setPaletteMode(next);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ paletteMode: next }));
    } catch (err) {
      console.error(err);
    }
  }, [paletteMode]);

  const value = {
    ...initialState,
    paletteMode,
    handleToggleTheme,
  };

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

SettingsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
